module.exports = __webpack_public_path__ + "static/media/icon-dashboard-commission-earned.21a22eb6.svg";